var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.249 6.7a1.184 1.184 0 0 0-1.697 0L9.6 16.842l-5.151-5.25a1.184 1.184 0 0 0-1.697 0 1.24 1.24 0 0 0 0 1.73l5.575 5.683a1.776 1.776 0 0 0 2.546 0L21.249 8.43a1.24 1.24 0 0 0 0-1.73"
  })));
};
export default SvgIconCheck;